import { getStringTypeProps } from '@blaze-cms/utils/src/helpers';
import getGenericRenderVariables from './get-generic-render-variables';
import buildRawQueryBase from './build-raw-query-base';
import buildSetFilters from './build-set-filters';
import { DEFAULT_LIMIT } from '../constants';

const filterQuerySetup = ({
  getEntitySchemas,
  entity,
  updatedFilterBy,
  variableProps,
  docType,
  filterOperator,
  filterEntityRelations,
  itemsToDisplay,
  entitySameAsCurrentItemEntity,
  entitySchema,
  useRandomSort = false
}) => {
  const stringProps = getStringTypeProps(entity, filterEntityRelations, getEntitySchemas);
  const filterValues =
    updatedFilterBy && updatedFilterBy.length
      ? buildSetFilters({ ...variableProps, filterBy: updatedFilterBy })
      : buildSetFilters(variableProps);

  const rawQuery = {
    bool: buildRawQueryBase({
      docType,
      filterValues,
      filterOperator,
      relations: filterEntityRelations,
      stringProps,
      itemsToDisplay,
      addListFiltersToQuery: true,
      entity,
      entitySchema
    })
  };

  // increase limit to get extra item in case results contain current parent
  const { limit: settingsLimit } = variableProps;
  const limit = settingsLimit || DEFAULT_LIMIT; // all falsey should use default
  const requestLimit = entitySameAsCurrentItemEntity ? Number(limit) + 1 : limit;
  const variables = getGenericRenderVariables({
    relations: filterEntityRelations,
    filterProps: { ...variableProps, limit: requestLimit },
    stringProps,
    rawQuery,
    useRandomSort
  });

  return { variables, limit };
};

export default filterQuerySetup;
